<ng-container *ngIf="item != null">
  <div class="tab-container d-flex align-items-center justify-content-center flex-column" [class.selected]="selected">
    <i [ngClass]="'fas ' + item!.icon!"></i>

    {{item.titleKey | translate}}
  </div>
</ng-container>